<app-page-header>Your policy</app-page-header>
<div class="container" [@fadeInOut]>
  <a
    routerLink="/services"
    queryParamsHandling="merge"
    class="link typog-body-large-bold mt-5 mb-5 d-block"
    ><i class="fa-solid fa-arrow-left mr-1"></i>Back</a
  >
  <div class="add-protection">
    <div class="add-protection__upsell">
      <div class="text--center">
        <h4 class="pl-5 pr-5">
          Let’s protect your {{ selected?.make }} {{ selected?.model }}
          {{ selected?.appliance_category }}
        </h4>

        <div class="add-protection__upsell-message">
          <p>
            <span
              class="typog-h4 xs--inline"
              *ngIf="
                itemOffer?.subsequentPayment <
                offers?.current_plan?.monthly_cost
              "
              >Now
            </span>
            <span class="typog-h1">{{
              itemOffer?.subsequentPayment | currency : 'GBP'
            }}</span
            ><span class="typog-h5"> a month</span>
          </p>
          <p class="typog-body-bold">For as long as you need</p>
        </div>

        <h5
          *ngIf="
            itemOffer?.subsequentPayment < offers?.current_plan?.monthly_cost
          "
          class="add-protection__upsell-price"
        >
          Your previous plan was
          <span>{{
            offers?.current_plan?.monthly_cost | currency : 'GBP'
          }}</span>
          a month
        </h5>
      </div>

      <p class="price-includes">Price includes Insurance Premium Tax or VAT.</p>
      <dgx-components-accordion [hasBorder]="false" [panels]="protectionPanels">
        <ng-template
          #accordionPanelHeaderTemplate
          let-expanded="expanded"
          let-panel="panel"
        >
          <div class="flex align--center">
            <dgx-components-icon
              class="icon-panel mr-3"
              [name]="panel.icon"
              [size]="'lg'"
            ></dgx-components-icon>
            <p class="typog-body-bold mr-4">{{ panel.title }}</p>
            <dgx-components-icon
              class="icon-chevron"
              [family]="'light'"
              [name]="expanded ? 'chevron-up' : 'chevron-down'"
              [size]="'md'"
            ></dgx-components-icon>
          </div>
        </ng-template>

        <ng-template
          #accordionPanelContentTemplate
          let-expanded="expanded"
          let-panel="panel"
        >
          <div>
            {{ panel.body }}
          </div>
        </ng-template>
      </dgx-components-accordion>
    </div>

    <div class="add-protection__terms">
      <dgx-components-accordion [hasBorder]="true" [panels]="[1]">
        <ng-template
          #accordionPanelHeaderTemplate
          let-expanded="expanded"
          let-panel="panel"
        >
          <div class="flex align--center justify--space-between">
            <h5 class="typog-body-bold-large">
              What’s not covered by this policy
            </h5>
            <dgx-components-icon
              [family]="'light'"
              [name]="expanded ? 'circle-xmark' : 'circle-plus'"
              [size]="'lg'"
            ></dgx-components-icon>
          </div>
        </ng-template>

        <ng-template
          #accordionPanelContentTemplate
          let-expanded="expanded"
          let-panel="panel"
        >
          <div>
            <ul class="list">
              <li class="flex mb-2">
                <dgx-components-icon
                  [name]="'xmark-circle'"
                  [size]="'sm'"
                  class="mr-2"
                ></dgx-components-icon>
                Cosmetic damage (such as scratches) or deliberate damage
              </li>
              <li class="flex mb-2">
                <dgx-components-icon
                  [name]="'xmark-circle'"
                  [size]="'sm'"
                  class="mr-2"
                ></dgx-components-icon>
                Costs that you may incur as a result of not being able to use
                your product
              </li>
              <li class="flex">
                <dgx-components-icon
                  [name]="'xmark-circle'"
                  [size]="'sm'"
                  class="mr-2"
                ></dgx-components-icon>
                Installation and recycling charges for a replacement appliance
              </li>
            </ul>
          </div>
        </ng-template>
      </dgx-components-accordion>
      <dgx-components-accordion [hasBorder]="true" [panels]="[1]">
        <ng-template
          #accordionPanelHeaderTemplate
          let-expanded="expanded"
          let-panel="panel"
        >
          <div class="flex align--center justify--space-between">
            <h5 class="typog-body-bold-large">Things you need to know</h5>
            <dgx-components-icon
              [family]="'light'"
              [name]="expanded ? 'circle-xmark' : 'circle-plus'"
              [size]="'lg'"
            ></dgx-components-icon>
          </div>
        </ng-template>

        <ng-template
          #accordionPanelContentTemplate
          let-expanded="expanded"
          let-panel="panel"
        >
          <div>
            <p class="mb-2">
              This insurance policy meets the demands and needs of those who
              wish to insure their electronic appliances and/or household goods
              against breakdown and accidental damage.
            </p>
            <p class="mb-2">
              It might be different from the plan you had before and could provide a different level of cover.
            </p>
            <p class="mb-2">
              Your policy will begin once we have processed your application.
            </p>
            <p>
              Full details on how to submit a complaint can be found in the
              <a
                [href]="'/assets/pdf/' + pdfFolderPath.termsAndConditions"
                target="_blank"
                class="link"
                >terms and conditions.</a
              >
            </p>
          </div>
        </ng-template>
      </dgx-components-accordion>
    </div>
    <a
      [href]="'/assets/pdf/' + pdfFolderPath.termsAndConditions"
      class="link d-block mt-4 mb-2"
      target="_blank"
      (click)="trackEvent('policy')"
      >Policy Terms & Conditions</a
    >
    <a
      [href]="'/assets/pdf/' + pdfFolderPath.ipid"
      class="link d-block"
      target="_blank"
      id="warning"
      (click)="trackEvent('insurance')"
      >Insurance Product Information Document (IPID)</a
    >

    <div
      class="add-protection__prompt text--center"
      [class.add-protection__prompt--warn]="showWarning"
    >
      <div [class.is-hidden]="!showWarning">
        <dgx-components-icon
          class="circle-exclamation mb-1"
          [name]="'circle-exclamation'"
          [size]="'xl'"
        ></dgx-components-icon>

        <h4 class="mb-4">We wouldn’t want you to miss out</h4>
        <p class="mb-5">
          Without a new policy, you won't have accidental damage cover or get a
          replacement appliance if yours can't be fixed (unless your
          manufacturer guarantee covers it).
        </p>

        <h5>
          <span
            *ngIf="
              itemOffer?.subsequentPayment < offers?.current_plan?.monthly_cost
            "
            >Now</span
          >
          {{ itemOffer?.subsequentPayment | currency : 'GBP' }} a month
        </h5>
      </div>

      <div class="add-protection__cta">
        <dgx-components-button
          [iconName]="'shield-check'"
          [fill]="true"
          [iconAlign]="'left'"
          [tabIndex]="1"
          [type]="'button'"
          [variant]="'decoration-color-3'"
          (clicked)="addProtection(true, 'Let\'s protect it')"
        >
          {{ "Let's protect it" }}
        </dgx-components-button>

        <dgx-components-button
          class="mt-3"
          [tabIndex]="1"
          [fill]="true"
          [type]="'button'"
          [variant]="'secondary'"
          (clicked)="
            addProtection(
              false,
              showWarning ? 'Not now, thanks' : 'Continue without cover'
            )
          "
        >
          {{ showWarning ? 'Not now, thanks' : 'Continue without cover' }}
        </dgx-components-button>
      </div>
    </div>
  </div>
</div>
